import React, { useEffect, useRef, useState } from "react";

import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";

import api from "../../../api";
import { Button, RenderFormFieldsHOC, SkeletonFormView } from "../../../components";
import { NewBenefitModal } from "../Components/BenefitModal";
// import { API } from "../../../api/SampleResponse";

export const NewRule = () => {
    const [ruleUIConfigLoading, setRuleUIConfigLoading] = useState(false);
    // const [benefitConfigLoading, setBenefitConfigLoading] = useState(false);
    const [formSubmitClick, setFormSubmitClick] = useState(false);
    const [isFormError, setIsFormError] = useState(false)
    const [ruleUIConfig, setRuleUIConfig] = useState(null);
    const [benefitBaseLoading, setBenefitBaseLoading] = useState(false)
    const [benefitBase, setBenefitBase] = useState(null)
    const [showNewbenefitModal, setShowNewBenefitModal] = useState(false)
    const [createRuleLoading, setCreateRuleLoading] = useState({
        DRAFT: false,
        PUBLISHED: false
    })
    const configRef = useRef(null)
    const benefitModalRef = useRef(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (ruleUIConfig) {
            configRef.current = ruleUIConfig //in this way whenever I am changing the state I can manual trigger config to update and anyways render function call is happening
        }
    }, [ruleUIConfig])

    const getRuleUIConfig = async () => {
        try {
            setRuleUIConfigLoading(true)
            const config = await api.getUIConfig({
                catalogId: "RULE"
            })
            setRuleUIConfig(config)
            setRuleUIConfigLoading(false)
        } catch (err) {
            console.log(err)
            setRuleUIConfigLoading(false)
        }
    }

    const getBasebenefit = async ({ catalogType,
        catalogId,
        categoryType
    }) => {
        try {
            if (benefitModalRef && benefitModalRef.current) {
                benefitModalRef.current?.showModal()
            }
            setShowNewBenefitModal(true)
            setBenefitBaseLoading(true)
            const response = await api.getBasebenefit({
                catalogType,
                catalogId,
                categoryType
            })

            setBenefitBase(response)
            setBenefitBaseLoading(false)
        } catch (err) {
            setBenefitBaseLoading(false)
            setShowNewBenefitModal(false)
            toast.error("Unable to fetch", {
                position: "bottom-right"
            })

        }
    }

    const errorCallback = (error) => {
        // syncing isFormError and error states 
        if (isFormError !== error) {
            setIsFormError(error);
        }
    }

    const getSelectedRuleType = () => {
        //returns the selected Rule type from ruleUiConfig
        if (configRef.current) {
            const ruleTypeConfig = configRef.current.children[0].children[0]
            const { valueConfig: { selectedValues } } = ruleTypeConfig || {};

            if (selectedValues && selectedValues.length) {
                return selectedValues[0] //dropdown returns value in array format
            } else {
                return ""
            }
        }
        return ""
    }

    const saveRuleToDrafts = async ({
        catalogState = "DRAFT",
        catalogComponent,
    }) => {
        try {
            setCreateRuleLoading({
                DRAFT: true,
                PUBLISHED: false
            })
            const response = await api.createRule({
                catalogState,
                catalogComponent
            })

            const { catalogInstanceDetails: { catalogInstanceId, status } } = response || {}
            if (status === "SUCCESS") {
                toast.success('Rule saved successfully', {
                    position: "bottom-right"
                })
                navigate(`/rules/rule/${catalogInstanceId}?mode=view`, {
                    replace: true
                })
            }
            setCreateRuleLoading({
                DRAFT: false,
                PUBLISHED: false
            })
        } catch (err) {
            setCreateRuleLoading({
                DRAFT: false,
                PUBLISHED: false
            })
            toast.error("Unable to save rule to Drafts", {
                position: "bottom-right"
            })
        }
    }

    useEffect(() => {
        getRuleUIConfig()
    }, [])

    return (
        <div className="w-full h-full overflow-auto px-8 py-3">
            <p className="text-xl font-medium">Create Rule</p>
            <div className="flex flex-col gap-6 pt-4">
                {ruleUIConfigLoading && <SkeletonFormView />}

                {!ruleUIConfigLoading && ruleUIConfig &&
                    <>
                        <RenderFormFieldsHOC
                            config={ruleUIConfig}
                            parent={ruleUIConfig}
                            childIndex={0}
                            sectionId={""} //initially the Json has a PAGE as parent
                            formSubmitClick={formSubmitClick}
                            errorCallback={errorCallback}
                            rerenderFormUI={setRuleUIConfig}
                            viewMode={false}
                        />
                    </>
                }
                <div className="flex justify-end items-center gap-2 mt-2">
                    <Button
                        variant="primary"
                        disabled={benefitBaseLoading}
                        onClick={() => {
                            //check for the Rule type selected first
                            const selectedRuleType = getSelectedRuleType()
                            if (selectedRuleType) {
                                getBasebenefit({
                                    catalogId: "BENEFIT_BASE",
                                    catalogType: "BENEFIT",
                                    categoryType: selectedRuleType //pass the Ruletype selected above in rules form
                                })
                            } else {
                                toast.error("Please select a rule type", {
                                    position: "bottom-right"
                                })
                            }
                        }}
                    >
                        Add Benefits
                    </Button>
                    <Button
                        variant="primary"
                        disabled={createRuleLoading.DRAFT}
                        onClick={() => {
                            saveRuleToDrafts({
                                catalogState: "DRAFT",
                                catalogComponent: configRef.current
                            })
                        }
                        }
                    >
                        Save to Drafts
                    </Button>
                </div>
            </div>


            {/* Render Modal to add the Benefits */}

            {/* <div className="flex flex-col gap-6 pt-4">
                {benefitConfigLoading && <SkeletonFormView />}
                {
                    !benefitConfigLoading && benefitUIConfig &&
                    <>
                        {
                            RenderFormFields(benefitConfigRef.current, benefitConfigRef.current, 0, "", formSubmitClick)
                        }
                    </>
                }
            </div> */}
            {/* Once Benfits Added Show tabs of Benfits added, so that user can click to edit  */}

            {
                showNewbenefitModal &&
                <NewBenefitModal
                    showModal={showNewbenefitModal}
                    categoryType={getSelectedRuleType()}
                    formConfigLoading={benefitBaseLoading}
                    formConfig={benefitBase}
                    closeModalCallback={(newbenefitConfig) => {
                        setShowNewBenefitModal(false)
                        if (newbenefitConfig) {
                            //append in ruleUIConfig
                            setRuleUIConfig(prev => ({
                                ...prev,
                                children: [
                                    ...(prev.children),
                                    {
                                        ...newbenefitConfig
                                    }
                                ]
                            }))
                        }
                    }}
                    errorCallback={errorCallback}
                    ref={benefitModalRef}
                />
            }
        </div>
    )
}